// @flow

import * as React from "react";

// Effectify's legal pages (effectify.help). Checked 2026-10-11: each answers 200.
const TERMS_OF_USE_URL = "https://www.effectify.help/terms-of-use";
const PRIVACY_POLICY_URL = "https://www.effectify.help/privacy-policy";
const ACCESSIBILITY_STATEMENT_URL = "https://www.effectify.help/accessibility-statement/";
// "...is an Effectify product" (as on try-on.ai), tagged so Effectify's analytics can tell the visits came from here.
const EFFECTIFY_URL = "https://effectify.io?utm_source=scan2pay&utm_medium=footer";

// The footer of every page, signed in or not: Intuit's trademark notice and Effectify's legal links. inApp: the
// full-width bar at the bottom of the signed-in layout (styled like the sidebar); otherwise the plain sign-in page version.
function AppFooter({inApp}: {inApp?: boolean}): React.Node {
  return (
    <footer className={"app-footer" + (inApp ? " app-footer-in-app" : "")}>
      <div>Intuit, QuickBooks, QB, TurboTax, Credit Karma, and Mailchimp are registered trademarks of Intuit Inc.</div>
      <div>
        &copy; {new Date().getFullYear()} Effectify LTD. Scan2Pay (formerly QRify) is
        an <a className="app-footer-brand" href={EFFECTIFY_URL} target="_blank" rel="noopener noreferrer">Effectify</a> product.
        All rights reserved.
      </div>
      <nav className="app-footer-links" aria-label="Legal">
        <a href={TERMS_OF_USE_URL} target="_blank" rel="noopener noreferrer">Terms of Use</a>
        <span aria-hidden="true">·</span>
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        <span aria-hidden="true">·</span>
        <a href={ACCESSIBILITY_STATEMENT_URL} target="_blank" rel="noopener noreferrer">Accessibility Statement</a>
      </nav>
    </footer>
  );
}

export default AppFooter;
